import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyUbiflowApiService } from './company-ubiflow-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyUbiflowApiService extends GeneratedCompanyUbiflowApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
